import StyleSheet from 'react-native-extended-stylesheet';

export const style = StyleSheet.create({
  layout: {
    alignItems: 'center',
  },
  boxContainer: {
    marginHorizontal: 'auto',
  },
  boxContainerL: {
    paddingTop: '$space6',
    paddingBottom: '$space8',
  },
  boxContainerS: {
    paddingTop: '$space6',
    paddingBottom: '$space8',
  },
  title: {
    marginBottom: '$space6',
  },
  reassurance: {
    alignSelf: 'stretch',
    textAlign: 'center',
    lineHeight: 17,
  },
  divider: {
    marginVertical: '$space8',
  },
});
